import { createApi } from '@reduxjs/toolkit/query/react';
import { baseQueryWithReauth } from './utils';

const LINK_PAYS_URL= '/link_pay/expenses';
const CREATE_LINK_PAY = LINK_PAYS_URL;

export const linkpayApi = createApi({
    reducerPath: 'linkpayApi',
    baseQuery: baseQueryWithReauth,
    endpoints: builder => ({
        getLinkpaysList: builder.query({
            query: ({ params }) => ({
                url: LINK_PAYS_URL,
                params
            }),
            transformResponse: (response) => {
                const { update_time, ...data } = response;
                return ({
                    ...data,
                    updatedTime: update_time ?? Date.now(),
                });
            },
        }),
        getLinkpayDetail: builder.query({
            query: (id) => ({
                url: `${ LINK_PAYS_URL }/${ id }`,
            }),
            transformResponse: (response) => {
                const { update_time, ...data } = response;
                return ({
                    ...data,
                    updatedTime: update_time ?? Date.now(),
                });
            },
        }),
        createLinkpay: builder.mutation({
            query: ({ params }) => ({
                url: CREATE_LINK_PAY,
                method: 'POST',
                body: params,
            }),
        }),
        updateLinkpayDetail: builder.mutation({
            query: ({ params: { id, ...payload} }) => ({
                url: `${ LINK_PAYS_URL }/${ id }`,
                method: 'PATCH',
                body: payload,
            }),
        }),
        getLinkpayInvoice: builder.query({
            query: ({ params: { id } }) => ({
                url: `${ LINK_PAYS_URL }/${ id }/invoices`,
            }),
            forceRefetch: () => true,
        }),
        reissueLinkpayInvoice: builder.mutation({
            query: ({ params: { id, ...payload} }) => ({
                url: `${ LINK_PAYS_URL }/${ id }/invoices`,
                method: 'POST',
                body: payload,
            }),
        })
    })
});

export const {
    useGetLinkpaysListQuery,
    useGetLinkpayDetailQuery,
    useCreateLinkpayMutation,
    useUpdateLinkpayDetailMutation,
    useLazyGetLinkpayInvoiceQuery,
    useReissueLinkpayInvoiceMutation,
} = linkpayApi;
